import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "../context/LoginContext";
import {
    LogOut,
    Github,
    Facebook,
    Twitter,
    Linkedin,
    Youtube,
    User as UserIcon,
    CheckCircle2,
} from "lucide-react";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import apiConfig from "../config/apiConfig";
import { logout } from "../apis/backend";
import iiitblogo from "../images/iiitb_logo.png";
import "./StudentHome.css";
import LogoutButton from "./LogoutButton";
import HelpIcon from "../images/help_chat.png";
import HelpQueryPopup from "./QueryManager/HelpQuery/HelpQueryPopup";
import MyQueriesPopup from "./QueryManager/MyQuery/MyQueriesPopup";
import QueryChatPopup, {
    help_desk_query,
} from "./QueryManager/QueryChat/QueryChatPopup";
import AllQueriesPopup from "./QueryManager/AllQueries/AllQueriesPopup";
import { toast } from "../utils/toast";

function StudentRegistrationHome() {
    const { user } = useContext(LoginContext);
    const userEmail = user?.email_id || "Student";

    return (
        <div className="student-home-container">
            {/* Header */}
            <header className="student-header">
                <div className="header-left">
                    <img src={iiitblogo} alt="IIITB" className="header-logo" />
                    <div className="header-title-group">
                        <h1 className="header-inst-name">
                            International Institute of Information Technology Bangalore
                        </h1>
                        <span className="header-portal-name">Admissions Portal</span>
                    </div>
                </div>
                <div className="header-right">
                    <div className="user-profile">
                        <div className="user-avatar" title={userEmail}>
                            <UserIcon size={20} />
                        </div>
                        <span className="user-email-text">{userEmail.split("@")[0]}</span>
                    </div>
                    <LogoutButton className="logout-btn" />
                </div>
            </header>

            {/* Main Content */}
            <div className="content-section">
                <div className="d-flex justify-content-center align-items-center mt-5 mb-5 mx-3" style={{ minHeight: "35vh" }}>
                    <div style={{
                        maxWidth: "760px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #e5e7eb",
                        borderTop: "6px solid #2D88D4",
                        borderRadius: "12px",
                        padding: "32px",
                        boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.05)",
                        color: "#1f2937",
                        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
                        textAlign: "center"
                    }}>
                        <div className="d-flex flex-column align-items-center justify-content-center gap-3 mb-4">
                            <div style={{
                                backgroundColor: "#eff6ff",
                                padding: "16px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <CheckCircle2 size={48} color="#2D88D4" strokeWidth={1.5} />
                            </div>
                            <h2 style={{ margin: 0, fontSize: "26px", fontWeight: 700, color: "#111827", letterSpacing: "-0.01em" }}>Registration Successful</h2>
                        </div>
                        <p style={{ margin: "12px 0 0 0", fontSize: "16px", lineHeight: 1.6, color: "#4b5563" }}>
                            Thank you for registering on the <strong>IIIT Bangalore Admissions Portal</strong>.
                            Applications for <strong>B.Tech / Integrated M.Tech / M.Tech</strong> will be
                            <strong style={{ color: "#ef4444" }}> open soon</strong>.
                        </p>
                        <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #f3f4f6" }}>
                            <p style={{ margin: 0, fontSize: "15px", lineHeight: 1.6, color: "#6b7280" }}>
                                We will notify you via email when the application window opens. Once announced, you can
                                log in using the same email and password to apply for your chosen program.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="student-footer">
                <div className="footer-social">
                    <a href="https://www.facebook.com/IIITBofficial">
                        <Facebook size={20} />
                    </a>
                    <a href="https://x.com/IIITB_official">
                        <Twitter size={20} />
                    </a>
                    <a href="https://www.linkedin.com/school/iiitbofficial">
                        <Linkedin size={20} />
                    </a>
                    <a href="https://www.youtube.com/user/iiitbmedia">
                        <Youtube size={20} />
                    </a>
                </div>
                <div className="footer-copyright">
                    <p className="footer-text">
                        © 2026 International Institute of Information Technology - Bangalore
                    </p>
                    <p className="footer-support">
                        Support - admissions2026@iiitb.ac.in | +91 80 4140 7777 (9:00 AM –
                        5:00 PM)
                    </p>
                </div>
            </footer>
        </div>
    )
}

export default StudentRegistrationHome